/* eslint-disable no-useless-escape */
const phonePattern = /^[0-9]{10}$/;
/* eslint-disable no-useless-escape */
const emailPattern =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
const isValid = (pattern) => (value) => pattern.test(value);

export const emailIsValid = isValid(emailPattern);

export const phoneIsValid = isValid(phonePattern);
